import { FormattedMessage } from 'react-intl';

import { AccessStatus } from '@/modules/api/codegen';
import type { MessageKey } from '@/modules/localizations';
import { Button } from '@/modules/ui';
import { visibleOnRowHoverClassName } from '@/modules/ui/components/Table/Table.rules';

import * as felaRules from './ChangeStatusButton.rules';

export interface ChangeStatusButtonProps {
    onClick: () => void;
    newStatus: AccessStatus;
}

export const ChangeStatusButton = ({ onClick, newStatus }: ChangeStatusButtonProps) => {
    const messageKey: MessageKey =
        newStatus === AccessStatus.active
            ? 'user-administration.table.actions.grantAccess'
            : 'user-administration.table.actions.revokeAccess';

    return (
        <Button
            type='text'
            color={newStatus === AccessStatus.active ? 'accentPrimary' : 'inputsError'}
            customStyle={felaRules.hiddenButton}
            className={visibleOnRowHoverClassName}
            onClick={onClick}
        >
            <FormattedMessage id={messageKey} />
        </Button>
    );
};
